import numeral from "numeral";

export function toCurrency(numb){
  return numeral(numb).format('$0,0.00');
}


// WEBPACK FOOTER //
// ./src/utilities/currency/index.js